<script setup lang="ts">
// Something shown full screen over the app (HRTH-188): a header with its name, a line under
// it and actions on the right; Close and Escape leave. Library albums (PhotoViewer) and
// chat attachments (MediaView) fill the rest.
import { onBeforeUnmount, onMounted } from 'vue'
import Icon from './Icon.vue'

defineProps<{ title: string }>()
const emit = defineEmits<{ close: [] }>()

function onKey(e: KeyboardEvent): void {
  if (e.key === 'Escape') emit('close')
}
onMounted(() => window.addEventListener('keydown', onKey))
onBeforeUnmount(() => window.removeEventListener('keydown', onKey))
</script>

<template>
  <Teleport to="body">
    <div class="fixed inset-0 z-50 flex flex-col bg-black text-white" role="dialog" :aria-label="title" data-testid="photo-viewer">
      <div class="flex h-14 shrink-0 items-center gap-2 px-2">
        <button class="flex h-11 w-11 items-center justify-center text-white/80 hover:text-white" aria-label="Close" data-testid="photo-close" @click="emit('close')">
          <Icon name="close" :size="5" />
        </button>
        <div class="min-w-0 flex-1">
          <div class="truncate text-sm" data-testid="photo-title">{{ title }}</div>
          <div class="mono truncate text-white/60"><slot name="sub" /></div>
        </div>
        <slot name="actions" />
      </div>
      <slot />
    </div>
  </Teleport>
</template>
